import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import {
  loadReportCompletion,
  loadRefersCompletion,
  loadRefersListCompletion,
} from '../../actions';

export function* watchLoadReport() {
  yield takeEvery('LOAD_REPORT', function*() {
    const options = {
      url: '/api/b/performance/index',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadReportCompletion(result.data, result.error));
  });
}

export function* watchLoadRefers() {
  yield takeEvery('LOAD_REFERS', function*() {
    const options = {
      url: '/api/b/referrer/mine',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadRefersCompletion(result.data, result.error));
  });
}

export function* watchLoadRefersList() {
  yield takeEvery('LOAD_REFERS_LIST', function*(action) {
    const range = action.range;
    const options = {
      url: `/api/b/referrer/list?start=${range.location}&size=${range.length}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadRefersListCompletion(range, result.data, result.error));
  });
}

export default function* reportSaga() {
  yield all([
    fork(watchLoadReport),
    fork(watchLoadRefers),
    fork(watchLoadRefersList),
  ]);
}
